/**
 *
 * Asynchronously loads the component for OrderHistory
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
